import { inject } from '@angular/core';
import { Auth, user } from '@fido/firebase/auth';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { isKaizenEmail } from '../auth/utils/is-kaizen-email';

export const changelogGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const auth = inject(Auth);

  const u = await firstValueFrom(user(auth));

  if (!u) return new RedirectCommand(router.parseUrl('/sign-in'));

  if (!u.email) throw new Error('User email is undefined');

  const allowed = isKaizenEmail(u.email);

  if (!allowed) return new RedirectCommand(router.parseUrl('/'));

  return allowed;
};
